module.exports = __webpack_public_path__ + "static/media/tictaktoe.f13450cd.png";